import { render, staticRenderFns } from "./InsightsByUser.vue?vue&type=template&id=2ee7908b&"
import script from "./InsightsByUser.vue?vue&type=script&lang=js&"
export * from "./InsightsByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports